<template>
  <dialog-card title="Opłata za interwencję" :actions="actions" :handler="handlerClick" titleClass="pb-0" ref="card">
    <v-card-text class="pt-0 px-0">
      {{ subtitle }}
    </v-card-text>
    <v-card-text>
      <payment-list :payments="costs" @payment-changed="onPaymentChanged" />
    </v-card-text>
  </dialog-card>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  name: "PaymentDialog",
  data: () => ({
    actions: {
      false: 'Anuluj',
      true: {
        color: 'success',
        text: 'OK',
      },
    },
    tasks: null,
  }),
  mounted() {
  },
  props: {
    site: {
      type: Object,
      default: null
    },
    costs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tags: get("payments/items"),
    subtitle() {
      return this.$options.filters.siteFullName(this.site)
    }
  },
  methods: {
    onEnter() {
      this.$refs.card.$refs.actions.trigger(true)
    },
    onPaymentChanged({ index, value }) {
      const oldValue = this.costs[index].token?.value ?? 0;
      const newValue = value?.value ?? 0;
      this.costs[index].updated = oldValue !== newValue;
      this.costs[index].newToken = value;
    },
    handlerClick(res, action) {
      if (!action.key) {
        this.$emit('submit', action.key)
      }
      const valid = this.rules ? this.$refs.input.validate() : true
      if (!valid) {
        this.$refs.input.focus()
        return false
      }
      this.$emit('submit', action.key ? this.costs : action.key)
    },
  },
};
</script>
<style>
.vuedl-layout__closeBtn {
  color: white;
}

.v-application--is-ltr .vuedl-layout__closeBtn {
  right: 14px;
}

.v-application--is-rtl .vuedl-layout__closeBtn {
  left: 14px;
}

.vuedl-layout__closeBtn:hover {
  opacity: 1;
}
</style>
